
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2bd1f5cc&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./WebhooksSettings.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./WebhooksSettings.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-2bd1f5cc!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./WebhooksSettings.vue"),
  /* scopeId */
  "data-v-2bd1f5cc",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/settings/WebhooksSettings.vue
// module id = 309
// module chunks = 2